import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { alertActions, breadcrumbsActions, masterProfilesActions as myActions, discoveryActions } from '../../../_services/essentials/store';
import Pagination from '@mui/material/Pagination';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid2";
import { DataGrid } from "@mui/x-data-grid";

import Avatar from "@mui/material/Avatar";
import { ArrowForwardOutlined } from '@mui/icons-material';
import PersonIcon from '@mui/icons-material/Person';
import { StyledText } from '../../../_services/essentials/functions/custom_style';
import {
    Button,
    Stack,
    FormControl,
    TextField,
    IconButton,
    Tooltip,
    Select,
    MenuItem,
    InputLabel, OutlinedInput, Chip
} from '@mui/material';
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import CircularProgress from '@mui/material/CircularProgress';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import ReactCountryFlag from "react-country-flag"
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { PieChart } from "@mui/x-charts/PieChart";
import { useDrawingArea } from "@mui/x-charts/hooks";
import { history } from '../../../_services/essentials/helpers';

import Search from '_components/common/Search';
import TuneIcon from "@mui/icons-material/Tune";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import CancelIcon from "@mui/icons-material/Cancel";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import ClearIcon from "@mui/icons-material/Clear";
export { List };

function List() {

    const entities_name = "dol_profiles";

    const textEllipsis = {
        display: '-webkit-box',
        WebkitLineClamp: 4,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'normal',
    };
    const dispatch = useDispatch();
    const loggedInUser = useSelector(x => x.auth.loggedInUser);
    const listAPIResponse = useSelector(x => x.masterProfiles?.listAPIResponse);
    const entity = useSelector(x => x.discovery?.filter);
    const userProject = history.location?.state?.selectedUserProject;
    const projectId = userProject?.id;
    const isProjectInIdentificationType = !!(userProject && userProject.type && userProject.type.id === 1);

    const [loading, setLoading] = useState(true);
    const [entities, setEntities] = useState([]);
    const [totalPages, setTotalPages] = useState('');
    const [totalItems, setTotalItems] = useState('');
    const [onLoadWait, setOnLoadWait] = useState(true);
    const entities_label = userProject ? "DOL Profiles" : "My DOL";

    let allContinentsInMemory = null;

    dispatch(breadcrumbsActions.setCurrentURL({
        url: history.location?.pathname,
        state: history.location?.state
    }));

    useEffect(() => {

        dispatch(discoveryActions.getAllSpecialities()).unwrap();
        dispatch(discoveryActions.getAllContinents()).unwrap();
        dispatch(discoveryActions.getAllSearchTerms()).unwrap();
        dispatch(discoveryActions.getAllProfessionalActivities()).unwrap();
        dispatch(discoveryActions.getAllProfileCompletenessOptions()).unwrap();

    }, [dispatch] );

    useEffect(() => {
        if (
            listAPIResponse &&
            listAPIResponse.value &&
            Array.isArray(listAPIResponse.value.list)) {
            setLoading(true);
            setEntities(listAPIResponse?.value?.list);
            setTotalPages(listAPIResponse?.value?.totalPages);
            setTotalItems(listAPIResponse?.value?.totalItems);

            setLoading(false);
        }
    }, [listAPIResponse]);

    const validationSchema = Yup.object().shape({
        // organizationName: Yup.string()
        //     .required('Organization Name is required'),
        // websiteURL: Yup.string()
        //     .required('websiteURL URL is required'),
    });
    const formOptions = { resolver: yupResolver(validationSchema) };
    const { register, handleSubmit, reset, control } = useForm(formOptions);

    //const [showProfileFilter, setShowProfileFilter] = useState(false);
    const showProfileFilter = false;
    const [filterModifiedFlag, setFilterModifiedFlag] = useState(false);
    const [selectedProfileIds, setSelectedProfileIds] = useState('');

    const [showDiscoveryFilter, setShowDiscoveryFilter] = useState(false);
    //const [discoveryFilter, setDiscoveryFilter] = useState(history.location?.state?.discovery_filter);
    const [discoveryFilter, setDiscoveryFilter] = useState({});

    const [masterProfileFilter, setMasterProfileFilter] = useState({
            projectId: projectId ?? -1,
            userId: loggedInUser?.id,
            searchTerms: "",
            selectedProfileIds: "",
        }
    );

    const [sortModel, setSortModel] = useState([
        {
            field: 'firstname',
            sort: 'asc',
        },
    ]);

    const [pageFilter, setPageFilter] = useState(() => ({
        pageNumber: 1,
        pageSize: 50,
        sortField: sortModel[0]?.field || 'firstname',
        sortDirection: sortModel[0]?.sort || 'asc',
        dataFilter: { masterProfileFilter },
    }));

    const updatePageFilter = (updates = {}) => {
        setPageFilter((prev) => ({
            ...prev,
            ...updates,
        }));
    };

    useEffect(() => {
        dispatch(breadcrumbsActions.setCurrentTitle(entities_label));
        if(!onLoadWait) {
            setLoading(true);
            dispatch(myActions.getPaginatedList(pageFilter));
        }
    }, [pageFilter, onLoadWait]);

    useEffect(() => {
        if(onLoadWait){
            setLoading(true);
            const timeoutId = setTimeout(() => {
                setOnLoadWait(false);
            }, 100);

            return () => clearTimeout(timeoutId);
        }
    }, [onLoadWait]);

    useEffect(() => {
        setLoading(true);
        setEntities([]);
        setMasterProfileFilter({
            projectId: projectId ?? -1,
            userId: loggedInUser?.id,
            searchTerms: "",
            selectedProfileIds: ""
        });
    }, [projectId]);

    useEffect(() => {
        setLoading(true);
        setPageFilter({
            ...pageFilter,
            "pageNumber": 1,
            dataFilter: { masterProfileFilter },
        });
    }, [masterProfileFilter]);

    useEffect(() => {
        //alert('JSON.stringify(discoveryFilter): '+JSON.stringify(discoveryFilter));
        setMasterProfileFilter({
            ...masterProfileFilter,
            discoveryFilter: discoveryFilter ? JSON.stringify(discoveryFilter) : ""
        });
    }, [discoveryFilter]);


    function navigatePage(event, newPageNumber) {
        setLoading(true);
        setPageFilter({
            ...pageFilter,
            "pageNumber": newPageNumber
        });
    }

    function PieCenterLabel({ primaryText, secondaryText }) {
        const { width, height, left, top } = useDrawingArea();
        const primaryY = top + height / 2;

        return (
            <React.Fragment>
                <StyledText variant="body2" x={left + width / 2} y={primaryY}>
                    {primaryText}
                </StyledText>
            </React.Fragment>
        );
    }

    async function searchProfile(data) {
        dispatch(alertActions.clear());
        try {
            const newSearchTerms = data.new_search_terms;
            setLoading(true);
            updatePageFilter({
                dataFilter: {
                    masterProfileFilter: {
                        ...masterProfileFilter,
                        searchTerms: newSearchTerms,
                    }
                }
            });
        } catch (error) {
            dispatch(alertActions.error(error));
        }
    }

    async function downloadprofiles() {
        const downloadPageFilter = {
            ...pageFilter,
            dataFilter: {
                masterProfileFilter: {
                    ...masterProfileFilter,
                    "selectedProfileIds": JSON.stringify(selectedProfileIds) || ''
                }
            }
        };
        setLoading(true);
        setTimeout(function(){
            setLoading(false);
        },10000);
        await dispatch(myActions.downloadprofilesByFilter(downloadPageFilter)).unwrap();
        setLoading(false);

    }

    const columns = [
        {
            field: 'ranking',
            renderHeader: () => (<h6><strong>{'Rank'}</strong></h6>),

            // headerAlign: 'center',
            // align: 'left',
            // minWidth: 50,
            flex: .26,
            hideable: true,
            renderCell: (params) =>
                <Stack
                    direction="column"
                    justifyContent="center"
                    alignItems="left" // Center horizontally
                    sx={{
                        width: '100%', height: '100%',
                    }}
                >
                    <Typography
                        variant="subtitle2"
                        sx={{ fontSize: '18px' }}
                    >
                        {params.row.ranking ? '#' + params.row.ranking : ''}
                    </Typography>
                </Stack>
        },
        {
            field: 'firstname',
            //renderHeader: () => (<Stack sx={{width: '500px', alignContent: 'center', alignItems: 'center'}}><h6><strong>{`KOL Card`}</strong></h6></Stack>),
            renderHeader: () => (<h6><strong>{'KOL Card'}</strong></h6>),
            //headerAlign: 'left',
            flex: 1,
            maxWidth: 450,
            minWidth: 320,
            renderCell: (params) =>
                <Stack direction="row" sx={{ py: 1, alignItems: 'center', width: '100%', }}>
                    <Stack direction="column"
                           justifyContent="center"
                           alignItems="left"
                           fullwidth="true"
                    >
                        <Link to={`/${entities_name}/view/${params.row.id}`}>
                            {params.row.profileImage?.imageLink ? (
                                <Avatar
                                    size="small"
                                    src={params.row.profileImage?.imageLink}
                                    sx={{ width: 50, height: 50 }}
                                    href={`/${entities_name}/view/${params.row.id}`}
                                    slotProps={{
                                        img: {
                                            loading: "lazy",
                                        },
                                    }}
                                />
                            ) : (
                                // <Avatar {...uxTextAvatar(`${params.row.firstname} ${params.row.lastname}`)}
                                //         sx={{ width: 50, height: 50 }}
                                //         href={`/${entities_name}/view/${params.row.id}`} />
                                <Avatar
                                    // alt={stringAvatar(`${params.row.firstname} ${params.row.lastname}`)}
                                    src={null}
                                    sx={{ width: 42, height: 42, userSelect: 'none' }}
                                    slotProps={{
                                        img: {
                                            loading: "lazy",
                                        },
                                    }}
                                    href={`/${entities_name}/view/${params.row.id}`}
                                />
                            )}
                        </Link>
                    </Stack>
                    <Stack direction="column" sx={{ ml: 2, justifyContent: 'left', width: '100%' }}>
                        <Typography variant="subtitle1" sx={{
                            fontSize: '18px',
                        }} >
                            {params.row.salutation} {params.row.firstname} {params.row.lastname} {params.row.suffix}
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#4C58B2', fontWeight: '600' }}> {params.row.title}</Typography>
                        {/* <Typography variant="body2" sx={{}}> {params.row.primaryAffiliation}</Typography> */}
                        <Typography variant="body2" sx={{

                        }} >
                            {params.row.primaryAffiliation}
                        </Typography>
                        <Stack sx={{
                            justifyContent: 'space-between',
                            flexDirection: 'row',
                            alignItems: 'center',
                            width: '100%',
                        }}>
                            < Typography
                                variant="caption"
                                sx={{
                                    lineHeight: '24px',
                                    fontWeight: '500',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '4px'
                                }}
                            >
                                <ReactCountryFlag
                                    countryCode={params.row.countryRef.code}
                                    svg
                                    style={{
                                        width: "20px",
                                        height: "20px",
                                    }}
                                    title={params.row.countryRef.name}
                                />
                                {params.row.countryRef.name}
                            </Typography>

                            {/*Code for Star rating*/}
                            {/*<Typography variant="body2" sx={{}}>*/}
                            {/*    <Star sx={{*/}
                            {/*        color: 'gold',*/}
                            {/*        fontSize: 19, pb: .4*/}
                            {/*    }} />*/}
                            {/*    {params.row.startRating ? (params.row.startRating * 5) : 0}</Typography>*/}

                        </Stack>

                    </Stack>
                </Stack >
        },
        // {
        //     field: 'profession',
        //     renderHeader: () => (<h6><strong>{'Affliation'}</strong></h6>),
        //     headerAlign: 'center',
        //     align: 'center',
        //     flex: 0.5,
        //     minWidth: 10
        // },
        {
            field: isProjectInIdentificationType ? 'specialty' : 'areasOfInterests',
            renderHeader: () => (<h6><strong>{isProjectInIdentificationType ? 'Speciality':'Area of Research'}</strong></h6>),
            // headerAlign: 'center',
            // align: 'center',
            flex: 1,
            minWidth: 250,
            maxWidth: 400,
            renderCell: (params) =>
                <Box
                    sx={{
                        position: 'relative',
                        display: 'inline-block',
                        width: '100%',
                        pt: 1
                    }}
                >
                    {isProjectInIdentificationType ? (
                        <Tooltip title={params.row.specialty}>
                            <Stack sx={textEllipsis}>
                                <Typography variant="body1">
                                    {params.row.specialty}
                                </Typography>
                            </Stack>
                        </Tooltip>
                    ) : (
                        <Tooltip title={params.row.areasOfInterests}>
                            <Stack sx={textEllipsis}>
                                <Typography variant="body1">
                                    {params.row.areasOfInterests}
                                </Typography>
                            </Stack>
                        </Tooltip>
                    )
                    }
                </Box>

        },
        {
            field: 'totalProfessionalActivitiesCount',
            renderHeader: () => (<h6><strong>{'Professional Activities'}</strong></h6>),
            // flex: 0.25,
            // headerAlign: 'center',
            minWidth: 280,
            flex: 0.6,
            renderCell: (params) =>
                // <Stack direction="row" spacing={3} sx={{ alignItems: 'center' }}>
                <Stack direction="row" sx={{ py: 1, justifyContent: "left", mt: 1, }}>
                    <Stack direction="column">
                        <Stack direction="row" sx={{height: '50px'}}>
                            <Tooltip title="Clinical Trials" arrow placement="top">
                                <Stack direction="column"
                                       justifyContent="center"
                                       alignItems="left"
                                       sx={{
                                           // cursor: 'pointer',
                                           '&:hover': {
                                               '.icon': {
                                                   color: 'primary.main',
                                               },
                                           },
                                       }}
                                >
                                    <img className='icon' alt="Clinical Trials" height="30" width="30" src="/assets/images/profile/check.svg" />
                                </Stack>
                            </Tooltip>
                            <Stack direction="column" sx={{ flex:1, alignItems: 'left', ml:0.5, justifyContent: 'center' }}>
                                <Typography variant="subtitle2" sx={{ color: '#4C58B2' }}>
                                    {params.row.trialsCount | 0}
                                </Typography>
                            </Stack>
                        </Stack>
                        <Stack direction="row" sx={{ justifyContent: 'left' }}>
                            <Typography sx={{ width: '70px', fontSize:'10px', color: '#6d6d6d' }}>
                                Clinical Trials
                            </Typography>
                        </Stack>
                    </Stack>
                    <Stack direction="column">
                        <Stack direction="row" sx={{height: '50px'}}>
                            <Tooltip title="Publications" arrow placement="top">
                                <Stack direction="column"
                                       justifyContent="center"
                                       alignItems="left"
                                       sx={{
                                           ml: .5,
                                           // cursor: 'pointer',
                                           '&:hover': {
                                               '.icon': {
                                                   color: 'primary.main',
                                               },
                                           },
                                       }}
                                >
                                    <img className='icon' alt="Publications" height="30" width="30" src="/assets/images/profile/public.svg" />
                                </Stack>
                            </Tooltip>
                            <Stack direction="column" sx={{ flex:1, alignItems: 'left', ml:0.5, justifyContent: 'center' }}>
                                <Typography variant="subtitle2" sx={{ color: '#4C58B2' }}>
                                    {params.row.pubsCount | 0}
                                </Typography>
                            </Stack>
                        </Stack>
                        <Stack direction="row" sx={{ justifyContent: 'left' }}>
                            <Typography sx={{ width: '70px', fontSize:'10px', color: '#6d6d6d' }}>
                                Publications
                            </Typography>
                        </Stack>
                    </Stack>
                    <Stack direction="column">
                        <Stack direction="row" sx={{height: '50px'}}>
                            <Tooltip title="Conferences and Events" arrow placement="top">
                                <Stack direction="column"
                                       justifyContent="center"
                                       alignItems="left"
                                       sx={{
                                           ml: .5,
                                           // cursor: 'pointer',
                                           '&:hover': {
                                               '.icon': {
                                                   color: 'primary.main',
                                               },
                                           },
                                       }}
                                >
                                    <img className='icon' alt="Conferences and Events" height="30" width="30" src="/assets/images/profile/event.svg" />
                                </Stack>
                            </Tooltip>
                            <Stack direction="column" sx={{ flex:1, alignItems: 'left', ml:0.5, justifyContent: 'center' }}>
                                <Typography variant="subtitle2" sx={{ color: '#4C58B2' }}>
                                    {params.row.conferenceCount | 0}
                                </Typography>
                            </Stack>
                        </Stack>
                        <Stack direction="row" sx={{ justifyContent: 'left' }}>
                            <Typography sx={{ width: '70px', flex:1, alignItems: 'center', fontSize:'10px', color: '#6d6d6d' }}>
                                Conferences and Events
                            </Typography>
                        </Stack>
                    </Stack>
                    {!isProjectInIdentificationType ? (
                        <Stack direction="column">
                            <Stack direction="row" sx={{height: '50px'}}>
                                <Tooltip title="Awards" arrow placement="top">
                                    <Stack direction="column"
                                           justifyContent="center"
                                           alignItems="left"
                                           sx={{
                                               ml: .5,
                                               // cursor: 'pointer',
                                               '&:hover': {
                                                   '.icon': {
                                                       color: 'primary.main',
                                                   },
                                               },
                                           }}
                                    >
                                        <img className='icon' alt="Awards" height="30" width="30"
                                             src="/assets/images/profile/award.svg"/>
                                    </Stack>
                                </Tooltip>
                                <Stack direction="column"
                                       sx={{flex: 1, alignItems: 'left', ml: 0.5, justifyContent: 'center'}}>
                                    <Typography variant="subtitle2" sx={{color: '#4C58B2'}}>
                                        {params.row.awardsCount | 0}
                                    </Typography>
                                </Stack>
                            </Stack>
                            <Stack direction="row" sx={{justifyContent: 'left'}}>
                                <Typography sx={{width: '70px', fontSize: '10px', color: '#6d6d6d'}}>
                                    Awards
                                </Typography>
                            </Stack>
                        </Stack>
                    ) : (
                        <Stack direction="column">
                            <Stack direction="row" sx={{height: '50px'}}>
                                <Tooltip title="Association" arrow placement="top">
                                    <Stack direction="column"
                                           justifyContent="center"
                                           alignItems="left"
                                           sx={{
                                               ml: .5,
                                               // cursor: 'pointer',
                                               '&:hover': {
                                                   '.icon': {
                                                       color: 'primary.main',
                                                   },
                                               },
                                           }}
                                    >
                                        <img className='icon' alt="Awards" height="30" width="30"
                                             src="/assets/images/profile/association.svg"/>
                                    </Stack>
                                </Tooltip>
                                <Stack direction="column" sx={{flex: 1, alignItems: 'left', ml: 0.5, justifyContent: 'center'}}>
                                    {/*TODO: Change it to Association when the data is available*/}
                                    <Typography variant="subtitle2" sx={{color: '#4C58B2'}}>
                                        {params.row.associtationCount | 0}
                                    </Typography>
                                </Stack>
                            </Stack>
                            <Stack direction="row" sx={{justifyContent: 'left'}}>
                                <Typography sx={{width: '70px', fontSize: '10px', color: '#6d6d6d'}}>
                                    Associations
                                </Typography>
                            </Stack>
                        </Stack>
                    )
                    }
                </Stack>
        },
        {
            field: 'careerStatus',
            renderHeader: () => (<Stack sx={{alignContent: 'center'}}><h6><strong>{`Career Status`}</strong></h6></Stack>),
            headerAlign: 'center',
            //border:1,
            align: 'center',
            minWidth: 175,
            maxWidth: 200,
            //maxWidth: 200,
            // flex: 1,
            // minWidth: 125,
            // flex: .45,
            renderCell: (params) =>

                <Stack direction="row" sx={{
                    py: 1, alignItems: 'center', mt: 2, width: '100%'
                }}>
                    {(params.row.careerStatus === 'Peak' &&
                        <Stack direction="row"
                               justifyContent="center"
                               alignItems="center" sx={{ width: '45%', minWidth: '150px' }}>
                                <Stack sx={{mt:0.25}}>
                                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                        {params.row.careerStatus}
                                    </Typography>
                                </Stack>
                                <Stack sx={{ml:0.75}}>
                                    <img
                                        src="/assets/images/healthcare/peak.png"
                                        alt="Peak"
                                        style={{ height: '24px' }}
                                    />
                                </Stack>
                        </Stack>
                    )}
                    {(params.row.careerStatus === 'Rising Star' &&
                        <Stack direction="row"
                               justifyContent="center"
                               alignItems="center" sx={{ width: '35%', minWidth: '150px' }}>
                            <Stack sx={{mt:1}}>
                                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                    {params.row.careerStatus}
                                </Typography>
                            </Stack>
                                <Stack sx={{ml:0.75}}>
                                    <img
                                        src="/assets/images/healthcare/rising_star.png"
                                        alt="Rising Star"
                                        style={{ height: '24px' }}
                                    />
                                </Stack>
                        </Stack>
                    )}
                </Stack>
        },
        {
            field: 'profileDOLScoring.dolPercentage',
            renderHeader: () => (<Stack sx={{width: '140px', alignContent: 'center', alignItems:'center'}}><h6><strong>{`Social Media`}<br/>{`Contribution`}</strong></h6></Stack>),
            // align: 'center',
            // flex: 1,
            minWidth: 200,
            maxWidth: 220,
            //flex: .40,
            renderCell: (params) =>
                <Stack direction="column" sx={{
                    py: 1, alignItems: 'center', width: '100%', mt: 0.5
                }}>
                    {/* <Stack direction="column" sx={{ flexGrow: '1', gap: 1, ml: 2, alignItems: 'center' }}> */}
                    <Stack direction="column"
                           justifyContent="center"
                           alignItems="center" sx={{ width: '25%' }}>
                        <Box sx={{ width: '605px', height: '60px' }}>

                            <PieChart
                                colors={["#01910d", "#d8d8d8"]}
                                margin={{
                                    left: 0,
                                    right: 0,
                                    top: 0,
                                    bottom: 0,
                                }}
                                series={[
                                    {
                                        data: [
                                            { label: 'Influence', value: (params.row.profileDOLScoring?.dolPercentage ? (params.row.profileDOLScoring?.dolPercentage) : 0) },
                                            { label: '', value: (params.row.profileDOLScoring?.dolPercentage ? (100 - params.row.profileDOLScoring?.dolPercentage) : 100) }
                                        ],
                                        innerRadius: '77%',
                                        outerRadius: '97%',
                                        paddingAngle: 0,
                                        // highlightScope: { faded: 'global', highlighted: 'item' },
                                    },
                                ]}
                                height={55}
                                tooltip={{ trigger: 'none' }}
                                slotProps={{
                                    legend: {
                                        hidden: true
                                    },
                                }}
                            >
                                {/*<PieCenterLabel primaryText={`${params.row.profileDOLScoring?.socialMedia ? (params.row.profileDOLScoring.socialMedia * 100) : 0}%`} sx={{ fontSize: '12px' }} />*/}
                                <PieCenterLabel primaryText={`${params.row.profileDOLScoring?.dolPercentage}%`} sx={{ fontSize: '12px' }} />
                            </PieChart>
                        </Box>
                    </Stack>
                    {/* <Stack direction="column" sx={{ flexGrow: '1', gap: 1, ml: 2, alignItems: 'center' }}> */}
                    <Stack direction="column"
                           justifyContent="center"
                           alignItems="center" sx={{ width: '60%', ml: 1, color: '#00742E' }}>
                            <Typography component="h2" variant="h6" sx={{fontWeight: 'bold'}}>{params.row.profileDOLScoring?.kolAndDolStatus}</Typography>
                    </Stack>
                </Stack >
        },
    ];

    async function resetDiscoveryFilter() {
        reset();
        await dispatch(discoveryActions.getAllSpecialities()).unwrap();
        await dispatch(discoveryActions.getAllContinents()).unwrap();
        await dispatch(discoveryActions.getAllSearchTerms()).unwrap();
        await dispatch(discoveryActions.getAllProfessionalActivities()).unwrap();
        await dispatch(discoveryActions.getAllProfileCompletenessOptions()).unwrap();

        setDiscoveryFilter({});
    }

    async function searchFilter(data) {
        dispatch(alertActions.clear());
        try {
            setLoading(true);

            const filteredData = {
                specialities: entity.specialities.value,
                continents: entity.continents.value,
                search_terms: entity.search_terms.value,
                professional_activities: entity.professional_activities.value,
                profile_completeness_options: entity.profile_completeness_options.value
            };

            setDiscoveryFilter(filteredData);

        } catch (error) {
            dispatch(alertActions.error(error));
        }
    }

    async function handleCountrySelection (continentId, countryId, selectionFlag){
        const allContinents = allContinentsInMemory ? allContinentsInMemory : entity.continents.value;
        let continentObjectWithSelectedContinent = allContinents.filter(item => item.id === continentId);
        const allCountriesFromSelectedContinent = continentObjectWithSelectedContinent[0].countries;
        let countryObject = allCountriesFromSelectedContinent.filter(item => item.id === countryId)[0];

        countryObject = {
            ...countryObject,
            selected: selectionFlag
        };

        let allUpdatedCountriesFromSelectedContinent = [];

        await allCountriesFromSelectedContinent.map(country => {
            if(country.id === countryId) {
                allUpdatedCountriesFromSelectedContinent.push(countryObject);
            } else {
                allUpdatedCountriesFromSelectedContinent.push(country);
            }
        });

        let allUpdatedContinents = [];

        await allContinents.map(continent => {
            if(continent.id === continentId) {
                allUpdatedContinents.push(
                    {
                        ...continent,
                        countries: allUpdatedCountriesFromSelectedContinent
                    });
            } else {
                allUpdatedContinents.push(continent);
            }
        });

        allContinentsInMemory = allUpdatedContinents;
    }

    async function renderUpdatedCountrySelectionList() {

        if (allContinentsInMemory) {
            await dispatch(discoveryActions.updateContinentFilter(allContinentsInMemory)).unwrap();
            allContinentsInMemory = null;
        }
    }

    async function setShowCountryfilterByContinentId (continentId, selectionFlag){
        const allContinents = entity.continents.value;
        let continentObjectWithSelectedContinent = allContinents.filter(item => item.id === continentId)[0];

        continentObjectWithSelectedContinent = {
            ...continentObjectWithSelectedContinent,
            showCountryFilter: selectionFlag
        };

        let allUpdatedContinents = [];

        await allContinents.map(continent => {
            if(continent.id === continentId) {
                allUpdatedContinents.push(continentObjectWithSelectedContinent);
            } else {
                allUpdatedContinents.push(continent);
            }
        });

        //allContinentsInMemory = allUpdatedContinents;
        dispatch(discoveryActions.updateContinentFilter(allUpdatedContinents)).unwrap();

    }

    async function handleContinentSelection (continentId, selectionFlag){
        const allContinents = allContinentsInMemory ? allContinentsInMemory : entity.continents.value;
        let continentObjectWithSelectedContinent = allContinents.filter(item => item.id === continentId);

        let continentObject = continentObjectWithSelectedContinent[0];

        continentObject = {
            ...continentObject,
            selected: selectionFlag
        };

        let allUpdatedContinents = [];

        await allContinents.map(continent => {
            if(continent.id === continentId) {
                allUpdatedContinents.push(continentObject);
            } else {
                allUpdatedContinents.push(continent);
            }
        });

        await dispatch(discoveryActions.updateContinentFilter(allUpdatedContinents)).unwrap();
    }

    async function handleSpecialitiesSelection (specialityId, selectionFlag){
        const allSpecialities = entity.specialities.value;
        let selectedSpecialityObject = allSpecialities.filter(item => item.id === specialityId);

        let specialityObject = selectedSpecialityObject[0];

        specialityObject = {
            ...specialityObject,
            selected: selectionFlag
        };

        let allUpdatedSpecialities = [];

        await allSpecialities.map(speciality => {
            if(speciality.id === specialityId) {
                allUpdatedSpecialities.push(specialityObject);
            } else {
                allUpdatedSpecialities.push(speciality);
            }
        });

        await dispatch(discoveryActions.updateSpecialityFilter(allUpdatedSpecialities)).unwrap();
    }

    async function handleProfessionalActivitiesSelection (professionalActivityId, selectionFlag, selectedRangeId){
        const allProfessionalActivities = entity.professional_activities.value;
        let selectedProfessionalActivityObject = allProfessionalActivities.filter(item => item.id === professionalActivityId);

        let professionalActivityObject = selectedProfessionalActivityObject[0];

        professionalActivityObject = {
            ...professionalActivityObject,
            selected: selectionFlag,
            selected_range_id: selectedRangeId
        };

        let allUpdatedProfessionalActivities = [];

        await allProfessionalActivities.map(professionalActivity => {
            if(professionalActivity.id === professionalActivityId) {
                allUpdatedProfessionalActivities.push(professionalActivityObject);
            } else {
                allUpdatedProfessionalActivities.push(professionalActivity);
            }
        });

        await dispatch(discoveryActions.updateProfessionalActivityFilter(allUpdatedProfessionalActivities)).unwrap();
    }


    async function handleKeywordSearchTerm (e){
        const newSearchTerm = e.target.value;
        await dispatch(myActions.updateSearchTerm(newSearchTerm)).unwrap();
    }

    async function onSubmit(data) {
        dispatch(alertActions.clear());
        try {
            setDiscoveryFilter(data);
        } catch (error) {
            dispatch(alertActions.error(error));
        }
    }
    return (
        // <Box sx={{ minWidth: '1050px', }}>
        <Box sx={{ width: '99%', maxWidth: { sm: '100%', md: '100%' }, ml: 2 }}>
            <Stack direction="column" sx={{ flexGrow: '1', gap: 1, mb: 1, mt: 0.5 }}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ width: '100%' }}>
                    <Stack direction="row" spacing={2} sx={{ mb: 1, mt: 0.5 }} >
                        <Stack sx={{ pl: 4, width: '350px' }}>
                            <form name="filterForm" id="filterForm" onSubmit={handleSubmit(searchProfile)}>
                                <Search control={control} handleSubmit={handleSubmit} clearAction={searchProfile} />
                            </form>
                        </Stack>
                        <Button onClick={() => setShowDiscoveryFilter(!showDiscoveryFilter)} variant="outlined" color="primary"
                                size="small" startIcon={<TuneIcon />}
                                endIcon={showDiscoveryFilter ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                sx={{ justifyContent: 'center', backgroundColor: '#FFF', color: '#333333', border: 0 }}>
                            Filter
                        </Button>
                    </Stack>
                    <Stack direction="row" alignItems="center" >
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            endIcon={<FileDownloadOutlinedIcon />}
                            disabled={(totalItems===0) || selectedProfileIds?.length===0}
                            onClick={() => downloadprofiles()}
                        >
                            Download
                        </Button>

                        <Stack direction="row" alignItems="center"  >
                            <IconButton
                                sx={{
                                    justifyContent: 'left',
                                    border: 'none',
                                    '&:hover': {
                                        backgroundColor: 'transparent',
                                    },
                                    '&:focus': {
                                        outline: 'none',
                                    },
                                    color: '#4C58B2',
                                }}
                            >
                                <PersonIcon fontSize="large" />
                            </IconButton>
                            <Typography
                                variant="body1"
                                sx={{
                                    pr: 2,
                                    fontWeight: 600,
                                    color: '#4C58B2',
                                    textAlign: 'center',
                                    minWidth: '65px',
                                }}
                            >
                                {totalItems ? totalItems.toLocaleString() : 0}
                            </Typography>
                        </Stack>
                    </Stack>
                </Stack>
                {showDiscoveryFilter &&
                <Stack direction="column"
                    // sx={{ border: '1px solid #7daad6', mb: 1, borderRadius: '6px' }}
                       sx={{ pb: 2, border: '1px solid #E0E0E066', width: '100%' }}>
                    <form onSubmit={handleSubmit(searchFilter)}>
                        <Stack direction="column" sx={{ flexGrow: '1', gap: 1, mb: 0, ml: 2, mt: 1 }}>
                            {!(entity?.specialities?.loading || entity?.specialities?.error) &&
                            <FormControl>
                                <Stack direction="column" sx={{ flexGrow: '1', gap: 1, mb: 1, ml: 2 }}>
                                    <Stack sx={{ flexGrow: '1' }}>
                                        <Typography variant="body1" sx={{ fontWeight: 600, fontSize: 16 }}>
                                            KOLs Speciality
                                        </Typography>
                                    </Stack>
                                    <Stack direction="row" sx={{}}>
                                        {entity?.specialities?.value?.map(({ id, name, display_name, selected }, index) => (
                                            <Box key={id}>
                                                {/*<TextField key={`${id}-speciality`} hidden={true} id={`id`} name={"id"} value={id} {...register(`specialities.${index}.id`)} />*/}
                                                {/*<TextField key={`${id}-${name}-speciality`} hidden={true} id={`name`} name={"name"} value={name} {...register(`specialities.${index}.name`)} />*/}
                                                {/*<TextField key={`${id}-display-${display_name}-speciality`} hidden={true} id={`display_name`} name={"display_name"} value={display_name} {...register(`specialities.${index}.display_name`)} />*/}
                                                <FormControlLabel componentsProps={{ typography: { fontSize: '14px' } }} control={<Checkbox sx={{
                                                    border: '2px solid #4C58B2', boxShadow: 0,
                                                }} defaultChecked={selected} {...register(`specialities.${index}.selected`)} />} key={id} label={display_name} onClick={() => { handleSpecialitiesSelection(id, !selected); setFilterModifiedFlag(true);}} />
                                            </Box>
                                        ))}
                                    </Stack>
                                </Stack>
                            </FormControl>
                            }
                        </Stack>
                        <Stack direction="column" sx={{ ml: 2, width: '100%' }}>
                            {!(entity?.continents?.value?.loading || entity?.continents?.value?.error) &&
                            <Stack direction="column" sx={{ flexGrow: '1', gap: 1, mb: 2, ml: 2, width: '50%' }}>
                                <FormControl>
                                    <Stack sx={{ flexGrow: '1' }}>
                                        {/* <Typography component="h4" variant="h6" sx={{ fontSize: 16 }}> */}
                                        <Typography variant="body1" sx={{ fontWeight: 600, fontSize: 16 }}>
                                            Preferred geographic locations of the KOLs
                                        </Typography>
                                    </Stack>
                                    <Stack direction="row" sx={{ flexGrow: '1', flexWrap: 'wrap' }}>
                                        {entity?.continents?.value?.map(({ id, name, selected, showCountryFilter, countries, hidden }, index) => (
                                            <Box key={`${id}-continents}`} >
                                                <FormControlLabel componentsProps={{ typography: { fontSize: '14px' } }} control={<Checkbox sx={{
                                                    borderRadius: 0, border: '2px solid #4C58B2', boxShadow: 0, mt: 1
                                                }} defaultChecked={selected} {...register(`continents.${index}.selected`)} />} hidden={hidden} key={id} label={name} onClick={() => { handleContinentSelection(id, !selected); setFilterModifiedFlag(true);}} />
                                                {!hidden && !showCountryFilter && countries?.length > 0 &&
                                                <IconButton color="primary" size={"small"} sx={{mt:0, ml: -1, mr: 3, border: 0}} aria-label="add to shopping cart" onClick={() => setShowCountryfilterByContinentId(id, !showCountryFilter)}>
                                                    <KeyboardArrowRightIcon />
                                                </IconButton>
                                                }
                                                {!hidden && showCountryFilter && countries?.length > 0 &&
                                                <FormControl key={`${id}-geographic-country`} sx={{ mt:0, width: 400,}}>
                                                    <InputLabel>{name}</InputLabel>
                                                    <Select
                                                        key={`${id}--select-geographic-country`}
                                                        multiple
                                                        value={countries}
                                                        {...register(`continents.${index}.countries`)}
                                                        sx={{display: "flex",
                                                            flexDirection: "row",
                                                            // height: 'px',
                                                            overflow: "hidden",
                                                            overflowY: "auto",
                                                            border: 0,
                                                        }}
                                                        input={<OutlinedInput label="Multiple Select" />}
                                                        onClose={()=> renderUpdatedCountrySelectionList()}
                                                        renderValue={(countries) => (
                                                            <Stack gap={0.5} direction="row" flexWrap="wrap"
                                                                   sx={{height: '100%',}}
                                                            >
                                                                {countries?.map(({ id: country_id, name: country_name, shortName: country_shortName, selected: country_selected }, countryIndex) => (
                                                                    country_selected &&
                                                                    <Chip
                                                                        id={"countries"}
                                                                        name={"countries"}
                                                                        key={country_id}
                                                                        label={country_name}
                                                                        onDelete={async () => {
                                                                            await handleCountrySelection(id, country_id, !country_selected);
                                                                            renderUpdatedCountrySelectionList();
                                                                            //value.selected = true
                                                                            // setSelectedNames(
                                                                            //     selectedNames.filter((item) => item !== value)
                                                                            // )
                                                                        }
                                                                        }
                                                                        sx={{fontSize: '10px'}}
                                                                        deleteIcon={
                                                                            <CancelIcon
                                                                                onMouseDown={(event) => event.stopPropagation()}
                                                                            />
                                                                        }
                                                                    />
                                                                ))}
                                                            </Stack>
                                                        )}
                                                    >
                                                        {countries.map(({ id: country_id, name: country_name, shortName: country_shortName, selected: country_selected }, countryIndex) => (
                                                            <Box key={`${id}-countries`} >
                                                                <FormControlLabel componentsProps={{ typography: { fontSize: '14px' } }} control={<Checkbox sx={{
                                                                    borderRadius: 0, border: '2px solid #4C58B2', boxShadow: 0,
                                                                }} defaultChecked={country_selected} {...register(`continents.${index}.countries.${countryIndex}.selected`)} onClick={(e)=> {setTimeout(function(){handleCountrySelection(id, country_id, !country_selected)},100); setFilterModifiedFlag(true);}} />} key={country_id} label={country_name} />
                                                            </Box>
                                                            // <MenuItem
                                                            //     key={country_id}
                                                            //     value={country_name}
                                                            //     onClick={(e)=> {
                                                            //         handleCountrySelection(id, country_id, !country_selected);
                                                            //         setFilterModifiedFlag(true);
                                                            //     }}
                                                            //     sx={{ justifyContent: "space-between" }}
                                                            // >
                                                            //     {country_name}
                                                            //     {country_selected ? <CheckIcon color="info" /> : null}
                                                            // </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                                }
                                                {!hidden && showCountryFilter && countries?.length > 0 &&
                                                <IconButton color="primary" size={"small"} sx={{ml:1, mt:1, mr: 3, border:0}} onClick={() => setShowCountryfilterByContinentId(id, !showCountryFilter)}>
                                                    <KeyboardArrowLeftIcon />
                                                </IconButton>
                                                }
                                            </Box>
                                        ))}
                                    </Stack>
                                </FormControl>
                            </Stack>
                            }
                            {!(entity?.search_terms?.loading || entity?.search_terms?.error) &&
                            <Stack sx={{justifyContent: 'space-between', flexGrow: '1', mt: 1}}>
                                <TextField
                                    id="search_terms"
                                    name="search_terms"
                                    hidden
                                    variant='outlined'
                                    color='primary'
                                    multiline
                                    size="normal"
                                    rows={3}
                                    defaultValue={entity?.search_terms?.value?.search_terms}
                                    inputlabelprops={{shrink: true}}
                                    {...register('search_terms')}
                                />
                            </Stack>
                            }
                            <Stack direction="row" sx={{ width: '100%' }}>
                                <FormControl fullWidth>
                                    {!(entity?.professional_activities?.loading || entity?.professional_activities?.error) &&
                                    <Stack direction="column" sx={{
                                        mb: 1, ml: 2,
                                        // borderLeft: '1px solid #7daad6'
                                        width: '100%'
                                    }}>
                                        <Stack sx={{ justifyContent: 'space-between', flexGrow: '1', gap: 1 }}>
                                            {/* <Typography component="h4" variant="h6" sx={{ fontSize: 16 }}> */}
                                            <Typography variant="body1" sx={{ fontWeight: 600, fontSize: 16 }}>
                                                KOL Activities
                                            </Typography>
                                        </Stack>
                                        <Stack direction={'row'} sx={{flexGrow: '1', mt: 1 }}>
                                            {entity?.professional_activities?.value?.map(({ id, name, display_name, selected, selected_range_id, activity_count_ranges }, index) => (
                                            <FormControl fullWidth>
                                            <Stack key={id} direction={'row'} sx={{ width: '350px', mr: 2 }}>
                                                <FormControlLabel componentsProps={{ typography: { fontSize: '14px' } }} control={<Checkbox sx={{
                                                    border: '2px solid #4C58B2', boxShadow: 0,
                                                }} defaultChecked={selected} {...register(`professional_activities.${index}.selected`)} />} key={id} label={display_name} onClick={() => { handleProfessionalActivitiesSelection(id, !selected, selected_range_id); setFilterModifiedFlag(true);}} />
                                                {selected &&
                                                <Select
                                                    key={`${id}-activity_count_range.id`}
                                                    id={`${id}-activity_count_range.id`}
                                                    name={`${id}-activity_count_range.id`}
                                                    value={selected_range_id}
                                                    sx={{
                                                        border: 0,
                                                        height: '40px',
                                                        maxWidth: '150px',
                                                        backgroundColor: '#fff',
                                                        '&:hover': {
                                                            backgroundColor: '#fff'
                                                        },
                                                    }}
                                                    // error={Boolean(errors.customer.id)}
                                                >
                                                    {activity_count_ranges?.map((activityCountRange) => (
                                                        <MenuItem
                                                            key={`${id}-activity_count_range.id-${activityCountRange.id}`}
                                                            onClick={(e) => {
                                                                handleProfessionalActivitiesSelection(id, selected, activityCountRange.id)
                                                            }}
                                                            value={activityCountRange.id}>{activityCountRange.display_name}</MenuItem>
                                                    ))}
                                                </Select>
                                                }
                                            </Stack>
                                            </FormControl>
                                            ))}
                                        </Stack>
                                    </Stack>
                                    }
                                </FormControl>
                            </Stack>
                        </Stack>
                        <Stack direction="row" sx={{ justifyContent: 'center' }}>
                            <Stack direction="column" sx={{ gap: 1, ml: 2 }}>
                                <Button onClick={() => { resetDiscoveryFilter(); setFilterModifiedFlag(false); }} disabled={!filterModifiedFlag}
                                        variant="contained" color="primary" size="small" endIcon={<ClearIcon />}>
                                    Clear
                                </Button>
                            </Stack>
                            <Stack direction="column" sx={{ gap: 1, ml: 2 }}>
                                <Button variant="contained" color="primary" type="submit" disabled={!filterModifiedFlag}
                                        endIcon={<ArrowForwardOutlined />}>Search</Button>
                            </Stack>
                        </Stack>
                    </form>
                </Stack>
                }

                <Stack direction="column" sx={{ flexGrow: '1', gap: 1, minWidth: '800px' }} >
                    <Grid container spacing={2} columns={12}>

                        <Grid size={{ md: 12, lg: 12 }}>
                            <DataGrid
                                autoHeight
                                // rowHeight={250}
                                getRowHeight={() => 'auto'}
                                checkboxSelection
                                disableColumnFilter
                                disableColumnMenu
                                disableColumnSelector
                                disableColumnResize
                                hideFooterPagination={true}
                                rows={entities}
                                columns={columns}
                                onRowClick={(params) => {
                                    // navigate(`/${entities_name}/view/${params.row?.id}`);
                                    history.navigate(`/${entities_name}/view/${params?.row?.id}`);
                                }}

                                getRowClassName={(params) =>
                                    params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                                }
                                loading={loading}
                                components={{
                                    LoadingOverlay: CircularProgress,
                                }}
                                slotProps={{
                                    loadingOverlay: {
                                        variant: 'skeleton',
                                        // noRowsVariant: 'skeleton',
                                    },
                                }}
                                onStateChange={(newState) => {
                                    if (newState && newState.page) {
                                        setLoading(false);
                                    }
                                }}
                                sx={{
                                    minHeight: 550,
                                    height: '100%',
                                    border: 0,
                                    '& .MuiDataGrid-topContainer': {
                                        color: '#fff', // Text color
                                        // border: 0
                                    },
                                    '& .MuiDataGrid-row': {
                                        borderBottom: 0,
                                        cursor: 'pointer'
                                    },
                                    '& .MuiDataGrid-columnHeaders': {
                                        justifyContent: "center",
                                        alignItems: "left"
                                    },


                                }}
                                onRowSelectionModelChange={(selectedRowIds) => {
                                    setSelectedProfileIds(selectedRowIds);
                                }}
                                sortingMode="server"
                                sortingOrder={['asc', 'desc']}
                                sortModel={sortModel}
                                onSortModelChange={(newSortModel) => {
                                    setLoading(true);
                                    setSortModel(newSortModel);
                                    updatePageFilter({
                                        sortField: newSortModel[0]?.field,
                                        sortDirection: newSortModel[0]?.sort,
                                        pageNumber: 1
                                    });
                                }}
                                columnVisibilityModel = {
                                    {
                                        "ranking": isProjectInIdentificationType,
                                        "careerStatus": !isProjectInIdentificationType,
                                        "profileDOLScoring.dolPercentage": !isProjectInIdentificationType
                                    }
                                }
                            />
                        </Grid>
                    </Grid>
                    {(totalPages > 1) &&
                    <Pagination variant="outlined" color="primary" count={totalPages} page={pageFilter.pageNumber} onChange={navigatePage} />
                    }
                </Stack>
            </Stack>
        </Box >
    );
}